<ng-container *ngIf="formGroup">
  <button mat-button
          type="button"
          class="mimic-mat-select-field col__"
          cdkOverlayOrigin
          (click)="openOverlay()"
          #trigger="cdkOverlayOrigin">
    {{ selectedTag?.name || 'Select a response' }}
    <div class="mat-select-arrow-wrapper">
      <div class="mat-select-arrow"></div>
    </div>
  </button>
  <ng-container *ngIf="!tagCategory.locked">
    <button class="link pl-0 d-inline-block mt-0050 mb-0025"
            *appIfMinRole="getMinRole(tagCategory)"
            (click)="onAddNewResponseClick()">Create new response</button>
  </ng-container>
  <ng-template cdkConnectedOverlay
               (overlayOutsideClick)="closeOverlay()"
               [cdkConnectedOverlayOffsetY]="-44"
               [cdkConnectedOverlayOrigin]="trigger"
               [cdkConnectedOverlayWidth]="triggerWidth$ | async"
               [cdkConnectedOverlayMinWidth]="'300px'"
               [cdkConnectedOverlayOpen]="isOpen">
    <div class="w-100">
      <app-response-search [autoFocusDisabled]="autoFocusDisabled"
                           [limitToCampaignId]="campaignId"
                           [tagCategoryIds]="[tagCategory.id]"
                           (itemSelected)="onTagSelected($event)"
                           class="d-block">
        <ng-container *responseItemTmpl="let response = response">
          <div (click)="onTagSelected(response)"
               class="w-100">
            <div class="text__label">{{response | tagSelectLabel}}</div>
          </div>
        </ng-container>
        <ng-container *responseNoResultsTmpl>
          <ng-container *ngIf="!tagCategory.locked">
            <mat-list-item (click)="onAddNewResponseClick()"
                           class="d-block p-0075 pl-0100 color--blue c-pointer"
                           *appIfMinRole="getMinRole(tagCategory)">

              <i class="far fa-plus mr-0050 txt-14"></i>Add New Response
            </mat-list-item>
            <ng-container *ngIf="tagCategory.readonly">
              <mat-list-item *appIfInRole="['lead','organizer','activist']">
                No Results
              </mat-list-item>
            </ng-container>
          </ng-container>

          <div class="p-0075 pl-0100 color--gray"
               *ngIf="tagCategory.locked">
            No Results
          </div>
        </ng-container>
      </app-response-search>
    </div>
  </ng-template>

  <div *ngIf="selectedTag"
       class="mt-0075">
    <div *ngIf="selectedTag.tagType == 'Shift'">
      <app-shift-info-form [formControl]="shiftControl"></app-shift-info-form>
    </div>
    <div *ngIf="selectedTag.tagType == 'Notes'">
      <mat-form-field class="col__">
        <mat-label>Make a note</mat-label>
        <textarea matInput
                  [formControl]="noteControl"
                  matTextareaAutosize
                  matAutosizeMinRows="2"
                  matAutosizeMaxRows="5"
                  data-test-id="noteTagInput"></textarea>
      </mat-form-field>
    </div>
    <div *ngIf="selectedTag.tagType == 'Date'">
      <mat-form-field class="col__">
        <mat-label>Date</mat-label>
        <input matInput
               [matDatepicker]="datePicker"
               placeholder="MM/DD/YYYY"
               autocomplete="off"
               [formControl]="noteControl"
               name="date">
        <mat-datepicker-toggle matSuffix
                               [for]="datePicker">
          <mat-icon fontSet="far"
                    fontIcon="fa-calendar"
                    matDatepickerToggleIcon></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
        <app-input-error [formControlItem]="noteControl"></app-input-error>
      </mat-form-field>
    </div>
    <div *ngIf="selectedTag.tagType == 'Number'">
      <mat-form-field class="col__">
        <mat-label>Enter Number</mat-label>
        <input type="text"
               [formControl]="noteControl"
               matInput
               decimalMask
               data-test-id="numberInput" />
      </mat-form-field>
    </div>

    <ng-container *ngIf="tagCategory.attachmentsEnabled">
      <app-file-selector class="d-block mb-0050"
                         *ngIf="!hideAttachments"
                         [compact]="true"
                         [file]="fileControl.value"
                         (fileChange)="setFile($event, fileControl)">
      </app-file-selector>
    </ng-container>
  </div>
</ng-container>
